/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Reply_IncompleteInputs */

const en_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event has reply marked as incomplete.`)
};

const fr_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'evenement a une reponse marquee comme incomplete.`)
};

const de_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Antwort auf die Veranstaltung ist unvollständig.`)
};

const it_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La risposta all'evento è stata contrassegnata come incompleta.`)
};

const ru_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В сообщении отмечен ответ, который не завершен.`)
};

const es_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El evento tiene la respuesta marcada como incompleta.`)
};

const zh_cn2_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动回复被标记为未完成。`)
};

const ja_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの返信が未完了としてマークされています。`)
};

const hi_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस इवेंट का जवाब अधूरा है।`)
};

const pt_pt2_error_nav_reply_incomplete = /** @type {(inputs: Error_Nav_Reply_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento teve a resposta marcada como incompleta.`)
};

/**
* | output |
* | --- |
* | "Event has reply marked as incomplete." |
*
* @param {Error_Nav_Reply_IncompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_reply_incomplete = /** @type {((inputs?: Error_Nav_Reply_IncompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Reply_IncompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_reply_incomplete(inputs)
	if (locale === "de") return de_error_nav_reply_incomplete(inputs)
	if (locale === "it") return it_error_nav_reply_incomplete(inputs)
	if (locale === "ru") return ru_error_nav_reply_incomplete(inputs)
	if (locale === "es") return es_error_nav_reply_incomplete(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_reply_incomplete(inputs)
	if (locale === "ja") return ja_error_nav_reply_incomplete(inputs)
	if (locale === "hi") return hi_error_nav_reply_incomplete(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_reply_incomplete(inputs)
	return en_error_nav_reply_incomplete(inputs)
});